<template>
  <vue-headful :title="title + ' - ' + APP_NAME" />
</template>

<script>
export default {
  name: 'PageTitle',
  props: {
    title: String
  }
}
</script>

<style scoped></style>
